import { useRef } from 'react'
import { useSnackbar } from '@smwb/summer-ui'
import { UseMutation, UseMutationStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks'
import type {
  MutationDefinition,
  MutationResultSelectorResult,
  QueryArgFrom,
  ResultTypeFrom
} from '@reduxjs/toolkit/query'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useMutationSnackbar<T extends MutationDefinition<any, any, any, any>>(
  mutation: UseMutation<T>,
  successMessageCallback: (response: Awaited<ResultTypeFrom<T>>) => string | void,
  errorMessageCallback: (error: unknown) => string | void
): [
  (args: QueryArgFrom<T>) => Promise<void>,
  UseMutationStateResult<T, MutationResultSelectorResult<T>>
] {
  const [trigger, data] = mutation()
  const { addSnackbar } = useSnackbar()
  const addSnackbarRef = useRef(addSnackbar)

  const actionTrigger = async (args: QueryArgFrom<T>) => {
    try {
      const response = await trigger(args).unwrap()
      const message = successMessageCallback(response)

      if (message) {
        addSnackbarRef.current({
          message,
          position: 'top-right',
          variant: 'success'
        })
      }
    } catch (err) {
      const message = errorMessageCallback(err)

      if (message) {
        addSnackbarRef.current({
          message,
          position: 'top-right',
          variant: 'danger'
        })
      }
    }
  }

  return [actionTrigger, data]
}
